module.exports = __webpack_public_path__ + "img/Liaoning-power.6fe8589a.png";